<template>
<div class="chapter">
<div class="inner_page">
<section class="element element-container-single element-non-bodymatter element-type-titlepage title-page automatic-title-page" epub:type="titlepage" id="title-page">
<div class="title-page-title-subtitle-block">
<h1 class="title-page-title">Monsters, Movies &amp; Mayhem</h1>
</div>
<div class="title-page-contributor-block">
<div class="title-page-contributor-secondary-block">
<h2 class="title-page-contributor title-page-contributor-secondary title-page-contributor-with-introduction"><span class="title-page-contributor-introduction">Edited by</span> <span class="title-page-contributor-name">Kevin J. Anderson</span></h2>
</div>
</div>
<div class="publisher-block">
<div class="title-page-publisher-logo-block title-page-publisher-logo-aspect-square">
<div class="title-page-publisher-logo-size-container publisher-logo-width-500">
<a class="link-contains-image" href="http://www.wordfirepress.com" target="_blank"><img alt="WordFire Press" class="title-page-publisher-logo-image" src="images/original.jpg"/></a>
</div>
</div>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title-page.vue?bfd55c4c